import React from 'react';
import { GameUserStats } from '../Game_UserStats';
import ProgressBar from '../../../ui/ProgressBar';
import AvatarComposite from '../../Avatar/AvatarComposite';
import avatarGeometry from '../../Avatar/avatarGeometry.json';
import { AVATAR_PROFILES } from '../../Avatar/avatarModel';

export const HUD_AVATAR_CROP = Object.freeze({
  left: avatarGeometry.hudCrop[0],
  top: avatarGeometry.hudCrop[1],
  right: avatarGeometry.hudCrop[2],
  bottom: avatarGeometry.hudCrop[3],
});
const HUD_AVATAR_STYLE = Object.freeze({
  '--avatar-crop-scale': `${(avatarGeometry.canvas.width / (HUD_AVATAR_CROP.right - HUD_AVATAR_CROP.left)) * 100}%`,
  '--avatar-crop-x': `${-(HUD_AVATAR_CROP.left / avatarGeometry.canvas.width) * 100}%`,
  '--avatar-crop-y': `${-(HUD_AVATAR_CROP.top / avatarGeometry.canvas.height) * 100}%`,
});

function PlayerPanelComponent({
  player,
  currentHpPercentage,
  userMaxHp,
  xpProgress,
  xpForNextLevel,
  level,
  avatarConfig,
  avatarSelection,
  onOpenAppearance,
}) {
  const playerLevel = Math.max(1, Math.round(Number(level) || 1));
  const satiety = Math.min(
    100,
    Math.max(0, Number(player?.satiety ?? 100) || 0),
  );
  const hungerState = player?.hungerState || 'well_fed';
  const hungerLabel = {
    well_fed: 'Well fed',
    fed: 'Fed',
    hungry: 'Hungry',
    starving: 'Starving',
  }[hungerState] || 'Fed';
  const formatHealth = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '0.00';
    return numeric.toFixed(2);
  };
  return (
    <div className="player-info">
      <div className="player-info__identity">
        <button
          aria-label={`Open appearance editor for ${player?.name || 'Operative'}`}
          className="player-info__avatar-button"
          onClick={onOpenAppearance}
          title="Edit appearance"
          type="button"
        >
          <AvatarComposite
            className="player-info__avatar"
            config={avatarConfig}
            decorative
            renderProfile={AVATAR_PROFILES.PORTRAIT}
            selection={avatarSelection}
            style={HUD_AVATAR_STYLE}
          />
        </button>
        <div className="player-info__vitals">
          <div className="player-info__name">{player?.name || 'Unknown Operative'} ({playerLevel})</div>
          <div className="player-info__progress">
            <label>HP</label>
            <ProgressBar label="Health" value={currentHpPercentage} variant="hp" />
            <span>{formatHealth(player?.currentHp)} / {formatHealth(userMaxHp)}</span>
          </div>
          <div className="player-info__progress">
            <label>XP</label>
            <ProgressBar label="Experience" value={xpProgress} variant="xp" />
            <span>{player?.xp || 0} / {xpForNextLevel}</span>
          </div>
          <div className="player-info__progress">
            <label>Food</label>
            <ProgressBar
              label={`Satiety: ${Math.round(satiety)}%, ${hungerLabel}`}
              value={satiety}
              variant={`hunger-${hungerState}`}
            />
            <span>{Math.round(satiety)}% · {hungerLabel}</span>
          </div>
        </div>
      </div>
      <div className="player-info__stats">
        <GameUserStats stats={player?.statsCached} />
      </div>
    </div>
  );
}

const PlayerPanel = React.memo(PlayerPanelComponent);

export default PlayerPanel;
